export const ErrorService = {
    handleErrors,
    handleErrorsWithIgnore,
    registerGlobalErrorHandler,
    raiseError,
};

export class FetchError extends Error {
    constructor(responseData, ...params) {
        super(...params);
        this.responseData = responseData;
    }

    public responseData: any;
}

let globalErrorHandler: (...ex: any[]) => void;
function registerGlobalErrorHandler(callBack: (...ex: any[]) => void) {
    globalErrorHandler = callBack;
}

function raiseError(...ex) {
    if (!!globalErrorHandler) {
        globalErrorHandler(...ex);
    }
}

async function handleErrors(response, ignoreStart = 200, ignoreEnd = 299) {
    if (
        (response.type && response.type === "abort") ||
        (response.name && response.name === "AbortError")
    ) {
        throw response;
    }

    if (response instanceof TypeError) {
        raiseError(response);
        throw response;
    }

    if (response.status < ignoreStart || response.status > ignoreEnd) {
        const jsonPromise = response.json();
        await jsonPromise.then(data => {
            data.status = response.status;
            if (data.error_description) {
                throw new FetchError(data, data.error_description);
            } else if (data.error_messages) {
                throw new FetchError(data, data.error_messages.join("<br/>"));
            }
            throw new FetchError(data, response.statusText);
        });
    }
    return response;
}

async function handleErrorsWithIgnore(response, ignoreStatuses) {
    if (response instanceof TypeError) {
        raiseError(response);
        throw response;
    }
    if (!ignoreStatuses.includes(response.status)) {
        const jsonPromise = response.json();
        await jsonPromise.then(data => {
            data.status = response.status;
            if (data.error_description) {
                throw new FetchError(data, data.error_description);
            } else if (data.error_messages) {
                throw new FetchError(data, data.error_messages.join("<br/>"));
            }
            throw new FetchError(data, response.statusText);
        });
    }
    return response;
}
